(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/services/ticket-configs.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/services/ticket-configs.js');
"use strict";


if (svs.isServer) {
  const {
    core: trinidad
  } = require('@svenskaspelab/trinidad-core');
  const ContentUrlBuilder = trinidad.components.require('content', 'shared').apiUtils.ContentUrlBuilder;
  const fetchTicketConfigs = async req => {
    try {
      const path = new ContentUrlBuilder(req, 'basicfilter').addParams({
        channel: 'tur',
        contentType: 'cnt:ticketGame',
        count: 200
      }).build();
      const data = await trinidad.jupiter.callAsync({
        method: 'GET',
        path,
        req
      });
      return data.result;
    } catch (err) {
      throw new Error(err);
    }
  };
  module.exports = {
    fetchTicketConfigs
  };
} else {
  const fetchTicketConfigs = async () => {
    try {
      const path = new svs.content.shared.ContentUrlBuilder('basicfilter').addParams({
        channel: 'tur',
        contentType: 'cnt:ticketGame',
        count: 200
      }).build();
      const data = await svs.core.jupiter.callAsync({
        method: 'GET',
        path
      });
      return data.response.result;
    } catch (err) {
      throw new Error(err);
    }
  };
  setGlobal('svs.eInstant.shared.services', {
    fetchTicketConfigs
  });
}

 })(window);